var settings = {
  debug: true,
  api: {
    protocol: 'https',
    host: 'api.99logix.com',
    port: 443,
    base: 'api/v1'
  }
}

settings.api.url = `${settings.api.protocol}://${settings.api.host}:${settings.api.port}/${settings.api.base}/`

settings.facebook = {
  appId: '509019175958597'
}

settings.GA = {
  code: 'UA-83921030-1'
}

settings.raven = {
  "dsn" : 'https://090da9ea0de54e4f98c47844081239c1@sentry.io/129707',
  config: {}
}

module.exports = settings



// WEBPACK FOOTER //
// ./src/settings/ssr.js